// extracted by mini-css-extract-plugin
module.exports = {"root":"TitleStyle_root__1U3Dd","icon":"TitleStyle_icon__1CeAV"};